import $ from 'jquery';
const ajax = {
  request(param) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: param.method || 'get',
        url: param.url || '',
        data: param.data || '',
        dataType: param.type || 'jsonp',
        jsonp: 'callback',
        success: function (res) {
          resolve(res);
        },
        error: function (errMsg) {
          reject(errMsg);
        },
      });
    });
  },
};
export default ajax;
